(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prefecture', {
            parent: 'entity',
            url: '/prefecture?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prefecture.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prefecture/prefectures.html',
                    controller: 'PrefectureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prefecture');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('prefecture-detail', {
            parent: 'entity',
            url: '/prefecture/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prefecture.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prefecture/prefecture-detail.html',
                    controller: 'PrefectureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prefecture');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Prefecture', function($stateParams, Prefecture) {
                    return Prefecture.get({id : $stateParams.id});
                }]
            }
        })
        .state('prefecture.new', {
            parent: 'prefecture',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prefecture/prefecture-dialog.html',
                    controller: 'PrefectureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('prefecture', null, { reload: true });
                }, function() {
                    $state.go('prefecture');
                });
            }]
        })
        .state('prefecture.edit', {
            parent: 'prefecture',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prefecture/prefecture-dialog.html',
                    controller: 'PrefectureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Prefecture', function(Prefecture) {
                            return Prefecture.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prefecture', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prefecture.delete', {
            parent: 'prefecture',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prefecture/prefecture-delete-dialog.html',
                    controller: 'PrefectureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Prefecture', function(Prefecture) {
                            return Prefecture.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prefecture', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
